export enum ValidationErrorType {
  global = 'global',
  property = 'property',
}
